export const init = (context = document) => {
  // expand / collapse another element
  const toggleExpand = (toggle, targets) => {
    [...targets].forEach(target => {
      const isExpanded = target.dataset.visible;
      if (isExpanded) {
        target.removeAttribute("data-visible");
      } else {
        target.setAttribute("data-visible", true);
      }
      toggle.setAttribute("aria-expanded", !isExpanded);
    });
  };

  const toggles = context.querySelectorAll("[data-toggle-home-short]");
  [...toggles].forEach(toggle => {
    if (toggle.hasAttribute("data-toggle-expand")) {
      toggle.addEventListener(
        "click",
        () => {
          if (window.innerWidth < 700) {
            toggle.style.display = "none";
            const target = context.querySelectorAll(
              toggle.dataset.toggleExpand
            );
            toggleExpand(toggle, target);
            toggle.style.display = "none";
          } else {
            const target = context.querySelectorAll(
              ".home-section-short__tile__text"
            );
            toggleExpand(toggle, target);
            [...toggles].forEach(t => {
              t.style.display = "none";
            });
          }
        },
        false
      );
    }
  });
};
